<template>
  <v-container>
    <v-card class="mx-auto pa-4">
      <p class="display-1 text--primary">
        <v-icon>camera_alt</v-icon>
        {{ this.title }}
      </p>
      <p>
        <v-container v-if="this.snapshot != null">
          <v-row align="start" justify="start" no-gutters>
            <v-col cols="3">
              CAT Code:
            </v-col>
            <v-col>
              {{ this.snapshot.catCodeString }}
              <v-btn :href="'/catCode/' + this.snapshot.catCodeString" color="primary">
                {{ this.snapshot.catCodeString }} History
              </v-btn>
            </v-col>
          </v-row>
          <v-row align="start" justify="start" no-gutters>
            <v-col cols="3">
              Marketplace:
            </v-col>
            <v-col>
              {{ this.snapshot.marketplace.name }}
            </v-col>
          </v-row>
          <v-row align="start" justify="start" no-gutters>
            <v-col cols="3">
              Date Scanned:
            </v-col>
            <v-col>
              {{ this.snapshot.scanBeginDateTime | toDateOnly }}
              <v-btn v-if="this.snapshot.id && this.snapshot.scanEndDateTime"
                :to="{ name: 'Snapshot API Calls', params: { id: this.snapshot.id } }" color="secondary" small
                class="ml-2">
                <v-icon left small>mdi-api</v-icon> View API Calls
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="my-1"></v-divider>
          <template v-if="this.snapshot.soldTotalQty > 0">
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Total Sold Qty:
              </v-col>
              <v-col>
                {{ this.snapshot.soldTotalQty }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Min Sale price:
              </v-col>
              <v-col>
                {{ this.snapshot.soldMinPrice | toCurrency }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Average Sale price:
              </v-col>
              <v-col>
                {{ this.snapshot.soldWeightedAvgPrice | toCurrency }}
              </v-col>
            </v-row>
            <v-divider class="my-1"></v-divider>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Last Month Sold Qty:
              </v-col>
              <v-col>
                {{ this.snapshot.soldLastMonthQty }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Last Month Min Sale price:
              </v-col>
              <v-col>
                {{ this.snapshot.soldLastMonthMinPrice | toCurrency }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Last Month Average Sale price:
              </v-col>
              <v-col>
                {{ this.snapshot.soldLastMonthAvgPrice | toCurrency }}
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Listing Count:
              </v-col>
              <v-col>
                {{ this.snapshot.activeListingCount }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Refined / Qty Cap / Total Qty:
              </v-col>
              <v-col>
                {{ this.snapshot.refinedTotalQty }} / {{ this.snapshot.qtyCapTotalQty }} / {{
                  this.snapshot.activeTotalQty }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Refined / Qty Cap / Avg Price:
              </v-col>
              <v-col>
                {{ this.snapshot.refinedWeightedAvgPrice | toCurrency }} / {{ this.snapshot.qtyCapWeightedAvgPrice |
                  toCurrency }} / {{ this.snapshot.activeWeightedAvgPrice | toCurrency }}
              </v-col>
            </v-row>
            <v-row align="start" justify="start" no-gutters>
              <v-col cols="3">
                Refined Min Qty / Qty Cap / Min Qty to Scan:
              </v-col>
              <v-col>
                {{ this.snapshot.refinedMinQty }} / {{ this.snapshot.qtyCap }} / {{ this.snapshot.minQtyToScan }}
              </v-col>
            </v-row>
          </template>
          <v-divider class="my-1"></v-divider>
          <v-row align="start" justify="start" no-gutters>
            <v-col cols="3">
              Keywords:
            </v-col>
            <v-col>
              {{ this.snapshot.keywords }}
            </v-col>
          </v-row>
          <!-- <div class="my-2"></div> -->
          <!-- <v-row align="start" justify="start" no-gutters>
            <v-col cols="3">
              <v-btn color="primary" @click="onRecalculateSnapshot" :loading="isRecalculating"
                :disabled="isRecalculating">
                <v-icon left>refresh</v-icon> Recalculate Statistics
              </v-btn>
            </v-col>
            <v-col>
            </v-col>
          </v-row> -->
          <v-row align="start" justify="start" no-gutters class="mt-4">
            <v-col cols="3" class="mt-2">
              Latest Snapshots:
            </v-col>
            <v-col>
              <span v-for="marketplace in this.marketplaces" :key="marketplace.id">
                <v-btn :href="'/snapshot/latest/' + marketplace.name + '/' + snapshot.catCodeString" color="secondary"
                  class="mx-1">
                  {{ marketplace.name }}
                </v-btn>
              </span>
            </v-col>
          </v-row>
          <v-row align="start" justify="start" no-gutters>
            <v-col cols="3" class="mt-5">
              Filter:
            </v-col>
            <v-col>
              <v-radio-group v-model="filter" @change="onFilterChange" row>
                <v-radio label="All" color="blue" value="all" />
                <v-radio label="US" color="red" value="us" />
                <v-radio label="Refined" color="green" value="refined" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </p>
    </v-card>
  </v-container>
</template>

<script>
import { MarketplacesService } from '../../services/api/marketplaces';
import { SnapshotsService } from '../../services/api/snapshots';
const apiSnapshots = new SnapshotsService();
const apiMarketplaces = new MarketplacesService();

export default {
  props: {
    title: String,
    snapshot: Object,
  },
  data() {
    return {
      filter: 'refined', // Default filter option
      marketplaces: [],
    }
  },
  created() {
    apiMarketplaces.getMarketplaces().then((data) => {
      this.marketplaces = data;
    }).catch(error => {
      console.error("Error fetching marketplaces:", error);
    });
  },
  methods: {
    onFilterChange(newFilterVal) {
      console.log("onFilterChange called with:", newFilterVal);
      this.$emit('update:filter', newFilterVal);
    },
    // This is called from the server through SignalR
    onScanCompleted({ newSnapshotID }) {
      // TODO:  Refine this api call so it returns the part ID as well as the snapshot ID.
      //        This way we could check the PartID before making the call below to getSnapshot.
      this.$emit('snapshot-updated', newSnapshotID);
    },
    onRecalculateSnapshot() {
      this.isRecalculating = true;
      // Call the API to recalculate the snapshot
      apiSnapshots.recalculateSnapshot(this.snapshot.id).then((data) => {
        this.snapshot = data;
        this.$emit('snapshot-recalculated', data);
      }).catch(error => {
        console.error("Error recalculating snapshot:", error);
        this.$emit('snapshot-recalculation-error', error);
      }).finally(() => {
        this.isRecalculating = false;
      });
    }
  }
}
</script>